import { Marquee, loop } from 'dynamic-marquee';


document.addEventListener('DOMContentLoaded', () => {

	const $marquee = document.getElementById('nbMarquee');
	if (!$marquee) 
		return;

	const marquee = (window.m = new Marquee($marquee, {
		rate: -80,
	}));

	window.l = loop(
		marquee,
		[
			() =>  Object.assign(document.createElement("a"), { 
				innerHTML: $marquee.getAttribute('data-title') || '',
				href:  $marquee.getAttribute('data-url') || '#',
				className: "lnk",
			}),
		],
		() => {
			const $separator = document.createElement('div');
			$separator.className = 'sep';
			$separator.innerHTML = '&nbsp;';
			return $separator;
		},
	);

});

